import { bluePrimary, whiteSecondary } from 'src/styles/colors';
import styled from 'styled-components';
import { ILineStep } from '../types';

const verticalLine = `
  content: "";
  display: inline-block;
  width: 50%;
  height: 3px;
  position: absolute;
  top: 10px;
`;

export const StepContainer = styled.div<ILineStep>`
  margin: 0;
  text-align: center;
  display: inline-block;
  position: relative;
  padding: 24px;

  &:not(:first-child):before {
    ${verticalLine};
    left: 0;
    background-color: ${props =>
      props.beforeActive ? bluePrimary : whiteSecondary};
  }

  &:not(:last-child):after {
    ${verticalLine};
    right: 0;
    background-color: ${props =>
      props.afterActive ? bluePrimary : whiteSecondary};
  }

  &:first-of-type:after {
    ${verticalLine};
    right: 0;
    background-color: ${props =>
      props.afterActive ? bluePrimary : whiteSecondary};
  }
`;
